

















import { Vue, Component, Prop } from "vue-property-decorator";
import { Rule, Op, isCombinedOp } from "../core/messages";
import SimpleRule from "./SimpleRule.vue";
import CombinedRule from "./CombinedRule.vue";

@Component({})
export default class RuleWrapper extends Vue {
  // Props
  @Prop({ required: true, type: Object })
  value!: Rule;

  // Data
  combinedOps: Op[] = ["and", "or"];
  opChoices: Op[] = ["<", "<=", ">", ">=", "!=", "==", ...this.combinedOps];

  // Computed
  get componentToRender() {
    if (isCombinedOp(this.value.op)) {
      return CombinedRule;
    }
    return SimpleRule;
  }

  // Methods
  updateOp(op: Op) {
    const currentOpIsCombined = isCombinedOp(this.value.op);
    const opIsCombined = isCombinedOp(op);
    if (currentOpIsCombined === opIsCombined) {
      this.$emit("input", {
        ...this.value,
        op
      });
    } else {
      if (opIsCombined) {
        this.$emit("input", {
          op,
          rules: []
        });
      } else {
        this.$emit("input", {
          op,
          field: "roonVersion",
          value: ""
        });
      }
    }
  }

  // Life-cycle hooks
}
